<template>
  <v-container fluid class="container-patch">
    <v-card>
      <v-card-title class="justify-center">
        <h2 class="company-color-header">{{ deploymentGuide.title }}</h2>
      </v-card-title>
      <v-card-title class="justify-center">
        <h3 class="font-weight-regular">{{ deploymentGuide.subtitle}}</h3>
      </v-card-title>
      <v-card-text>
        <ol>
          <li v-for="item of deploymentGuide.items" :key="item.pos">
            <span v-html="item.title" />
            <ol type="a" v-if="item.subItems">
              <li v-for="subItem of item.subItems" :key="subItem.pos">
                <span v-html="subItem.title" />
              </li>
            </ol>
          </li>
        </ol>
      </v-card-text>
      <v-card-title class="justify-center">
        <h2 class="company-color-header">{{ deploymentGuide.footer }}</h2>
      </v-card-title>
    </v-card>
  </v-container>
</template>

<script>

export default {
  name: "DeploymentGuide",
  data() {
    return {
      deploymentGuide: {
        title: 'iAnnotate for Intune / O365',
        subtitle: 'Deployment Guide',
        items: [
          {pos: 1, title: 'Register in iAnnotate customer admin portal here: <a style="color: blue;" target="_blank" href="https://enterprise.iannotate.com/auth">https://enterprise.iannotate.com/auth</a>', subItems: [
            {pos: 1, title: 'You can download the app before or after completing these steps'},
            ]},
          {pos: 2, title: 'Go to “Company Information” section, enter your information, then click “save”', subItems: [
            {pos: 1, title: 'Tenant ID can be located here: <a style="color: blue;" target="_blank" href="https://docs.microsoft.com/en-us/onedrive/find-your-office-365-tenant-id?WT.mc">https://docs.microsoft.com/en-us/onedrive/find-your-office-365-tenant-id?WT.mc</a>'},
            ]},
          {pos: 3, title: 'Go to “iAnnotate Configuration” and set your configurations, then click “save”', subItems: [
            {pos: 1, title: 'The default App Configuration enables ‘OneDrive’ and ‘Local’ storage'},
            {pos: 2, title: 'A check mark next to a cloud storage means the drive is disabled'},
            {pos: 3, title: '“Disable Remote Connections” – if checked will only grant access to ‘Local’ storage, i.e., no cloud storages within iAnnotate’s library'},
            ]},
          {pos: 4, title: 'Go to the “License Key” section and press the “GENERATE LICENSE KEY” button', subItems: [
            {pos: 1, title: 'A License key will appear, select “COPY”'},
            {pos: 2, title: 'The default license is a 1 month Trial period. A customer service representative will contact you to discuss annual licensing'},
            ]},
          {pos: 5, title: 'Open Intune @ <a style="color: blue;" target="_blank" href="https://admin.microsoft.com/">https://admin.microsoft.com/</a> and log-in with your credentials', subItems: [
              {pos: 1, title: 'Go to Apps -> App configuration policies -> ‘+ Add’ -> managed apps'},
              {pos: 1, title: 'Name: iAnnotate for Intune / O365'},
              {pos: 1, title: 'Select “+ Select public apps” and find “iAnnotate for Intune / O365,” tap on it, then press “select” at the bottom, then tap “next”'},
              {pos: 1, title: 'Name: “IALicense”; Value: paste the License Key copied previously, tap Next'},
              {pos: 1, title: 'Assign a group to the app, tap Next, then review and tap “Create”'},
            ]},
          {pos: 6, title: 'If you have not already, download the “iAnnotate for Intune / O365” app from the Apple App Store and openFile the app on your company managed device', subItems: [
              {pos: 1, title: 'The app should recognize the license code and activate itself'},
              {pos: 2, title: 'Tap the “+” button to enable any selected cloud storages'},
            ]},
          {pos: 7, title: 'Please visit <a style="color: blue;" target="_blank" href="https://www.iannotate.com/features">https://www.iannotate.com/features</a> to download the latest user guide'},
          {pos: 8, title: 'Please contact us at <a style="color: blue;" href="mailto:support@branchfire.com">support@branchfire.com</a> with any questions/issues'},
        ],
        footer: 'Thank you for choosing iAnnotate -- Happy iAnnotating!'
      }
    }
  },
}
</script>
<style scoped>
.container-patch {
  font-family: Verdana;
}

.company-color-header {
  color: orangered;
}

.container-patch li {
  font-size: 1.15rem;
  margin: 10px 0;
}

.container-patch ol {
  margin: 20px 0;
}

</style>